import makeStyles from "@mui/styles/makeStyles";
import { BLUE, COLOR, LIGHT_BLUE, YELLOW } from "../components/utils";

export const usePointerStyles = makeStyles(() => ({
  root: {
    cursor: "pointer",
  },
}));
